module.exports = __webpack_public_path__ + "img/lock.c0ebe3a1.png";